export default [
  {
    path: "/grade/praiseList",
    name: "GradePraise",
    meta: {
      title: "课程点评",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/grade/gradePraise/GradePraise.vue")
  },
  {
    path: "/grade/gradeWorkList/:uid",
    name: "StudentsGradeWorkList",
    meta: {
      title: "点评展示",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/grade/studentsGradeWorkList/StudentsGradeWorkList.vue")
  },
  {
    path: "/grade/commentInfo",
    name: "CommentShow",
    meta: {
      title: "评价详情",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/grade/commentShow/CommentShow.vue")
  },
  {
    path: "/grade/praiseInfoShow",
    name: "ShowPraiseInfo",
    meta: {
      title: "评价详情展示",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/grade/showPraiseInfo/ShowPraiseInfo.vue")
  },
  {
    path: "/grade/commentPraiseInfo",
    name: "CommentPraiseInfo",
    meta: {
      title: "课次评价详情",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/grade/commentPraiseInfo/CommentPraiseInfo.vue")
  },
  {
    path: "/grade/commenting",
    name: "Commenting",
    meta: {
      title: "评价学员",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/grade/commentIng/CommentIng.vue")
  },
];